export default __webpack_public_path__ + "static/media/ico_logo_dk.3b6da65d.svg";